import { CheckForLocationConflictArgs, checkForTimelineItemTimeConflict } from '@modules/timetable';
import getConfirmChangeFunction from '@modules/timetable/functions/timeline/getConfirmChangeFunction';

const confirmChange = getConfirmChangeFunction({
  title: 'Location conflict',
  contentStartText: 'location you selected for this item is in use for',
});

export const checkForLocationConflict = ({
  timelineItems,
  item,
  endTime,
  startTime,
}: CheckForLocationConflictArgs): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    if (!item.locationID) {
      return resolve(true);
    }

    return checkForTimelineItemTimeConflict({
      filterField: 'locationID',
      timelineItems,
      item,
      resolve,
      startTime,
      endTime,
      confirmChange,
    });
  });
};
